import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { GoogleAnalytics } from './components/GoogleAnalytics';
export function App() {
  return <div className="min-h-screen bg-[#f8faff] dark:bg-[#0a0e17] text-gray-900 dark:text-white" data-id="element-0">
      <GoogleAnalytics data-id="element-1" />
      <Header data-id="element-2" />
      <main data-id="element-3">
        <Outlet data-id="element-4" />
      </main>
      <Footer data-id="element-5" />
    </div>;
}